<template>
  <!-- 下单页面 -->
  <div class="conmodporder">
    <div class="btop"><porderxz /></div>
    <div class="w10f8"><cdwritobtawh /></div>
    <div><cdwriserrelat /></div>
    <div class="w10f8"><cdwriteam /></div>
  </div>
</template>

<script>
import porderxz from "./child/porderxz"; //下单页正文
import cdwritobtawh from "views/conmodwrite/child/cdwritobtawh"; //你能获得什么
import cdwriserrelat from "views/conmodwrite/child/cdwriserrelat"; //服务流程
import cdwriteam from "views/conmodwrite/child/cdwriteam"; //服务团队&评价
export default {
  components: {
    cdwritobtawh,
    cdwriserrelat,
    cdwriteam,
    porderxz,
  },
};
</script>

<style lang="scss" scoped>
.conmodporder {
  .w10f8 {
    width: 100%;
    background: #f8f8f8;
  }
  .btop {
    width: 100%;
    border-top: 1px solid #eee;
  }
}
</style>